/**
 * Closing CTA for the homepage. Pickup and Uber Eats stay the same.
 */

import { Link } from 'react-router-dom';
import UberEatsOrderLink from '../../components/UberEatsOrderLink';
import type { PreviewContact } from './usePreviewHomeData';

export default function PreviewCta({ contact }: { contact: PreviewContact }) {
  const tel = contact.phone.replace(/\D/g, '');

  return (
    <section className="gradient-primary text-white section-padding">
      <div className="container-custom max-w-3xl text-center">
        <h2 className="font-display text-3xl font-bold md:text-4xl">Ready to order?</h2>
        <p className="mx-auto mt-4 max-w-xl text-lg text-white/90">
          Pickup at Commerce Park in Barrie. Order online or call the shop.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link to="/order" className="btn-secondary bg-white text-primary-700 hover:bg-bakery-cream">
            Order online
          </Link>
          <UberEatsOrderLink variant="cta" />
          <a
            href={`tel:${tel}`}
            className="btn-outline border-white text-white hover:bg-white hover:text-primary-700"
          >
            Call {contact.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
